import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {getLanguage} from '../../Util/language';
import '../../style/error.css';

interface TranslatorProps {
    parentPath?: string,
    path: string
}

const lang = getLanguage();
class Translator extends React.Component <RouteComponentProps & TranslatorProps, {}> {
    public static translate = (fullKey, defaultText) => {
        let transText = Translator.reachValue(Translator.lang.map, fullKey);
        let defaultTransText = Translator.reachValue(Translator.lang.defaultMap, fullKey);
        return transText || defaultTransText || defaultText;
    }

    private static delimiter = ".";

    private static lang = {
        map: require("../../resource/intl/" + lang + ".json"),
        defaultMap: require("../../resource/intl/en.json")
    }

    private static reachValue(map: object, key: string) {
        return key.split(this.delimiter).reduce((acc, i) => {
            if(acc)
                return acc[i];
            else
                return null;
        }, map);
    }


    public constructor(props: TranslatorProps) {
        super(props);
        this.getKey = this.getKey.bind(this);
    }

    public getKey() {
        let fullKey = this.props.path;
        if (this.props.parentPath !== undefined) 
            fullKey = this.props.parentPath + Translator.delimiter + fullKey;
        return fullKey;
    }


    public render() {
        let fullKey = this.getKey();
        let className = fullKey.replace(new RegExp(`\\${Translator.delimiter}`, 'g'), "-");
        return (
            <span className={className}>
                {Translator.translate(fullKey, this.props.children)}
            </span>
        );
    }
}

export default withRouter(Translator);


// WEBPACK FOOTER //
// ./src/Components/Translator/Translator.tsx